import http from '@root/utils/axios/admin';

let state = {
    GameTrailersList: [],
    GameTrailer: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGameTrailersList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/game-trailers', { params: filter }).then((response) => {
                commit('setGameTrailersList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteGameTrailer({ commit }, id) {
        return http.delete('user/game-trailers/' + id);
    },

    fetchGameTrailer({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/game-trailers/' + id).then((response) => {
                commit('setGameTrailer', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateGameTrailer({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/game-trailers', data).then((response) => {
                commit('setGameTrailer', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGameTrailerError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateGameTrailer({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/game-trailers/' + data.get('id'), data).then((response) => {
                commit('setGameTrailer', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGameTrailerError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setGameTrailersList(state, data) {
        state.GameTrailersList = data;
    },
    setGameTrailer(state, data) {
        state.GameTrailer.data = data;
    },
    setGameTrailerError(state, error) {

        state.GameTrailer.error = error.errors;
    },
    cleanGameTrailerError(state, error) {
        state.GameTrailer.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}